
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diamondhead/faq",
      function () {
        return require("private-next-pages/diamondhead/faq.js");
      }
    ]);
  